import StoreLocator from '../../../components/forms/StoreLocator/StoreLocator';
import { useEffect, useState } from 'react';
import { Radio, useId } from '@fluentui/react-components';
import useShippingMethodStyles from './ShippingMethod.styles';
import { useCart } from '../../../contexts/CartContext/CartContext.hooks';
import { IShippingMethod, ShippingMethod } from '../../../contexts/CartContext/CartContext.types';
import { DefaultShippingCost, IShipping } from '../../../types/Shipping';
import StoreLocatorApi from '../../../components/forms/StoreLocator/StoreLocator.api';

const ShippingMethodRadioGroup = () => {
    const { cart, updateShippingMethod } = useCart();

    const [method, setMethod] = useState('store');

    const [overnightShipping, setOvernightShipping] = useState(cart.shippingMethod.overnight);

    const [shippingCost, setShippingCost] = useState(DefaultShippingCost());

    const [postOfficeCost, setPostOfficeCost] = useState('Error: Contact Viaero for price');

    const [storeCost, setStoreCost] = useState('Error: Contact Viaero for price');

    useEffect(() => {
        let shippingMethod = ShippingMethod.StorePickup;
        let cost = 0;

        switch (method) {
            case 'post-office':
                shippingMethod = ShippingMethod.PostOffice;
                if (overnightShipping) cost = shippingCost.overnightPostOffice;
                else cost = shippingCost.postOffice;
                break;
            case 'store':
                shippingMethod = ShippingMethod.StorePickup;
                if (overnightShipping) cost = shippingCost.overnightStore;
                else cost = shippingCost.store;
                break;
        }

        const shipping: IShippingMethod = {
            ...cart.shippingMethod,
            cost: cost,
            method: shippingMethod,
            overnight: overnightShipping
        };

        updateShippingMethod(shipping);
    }, [method, overnightShipping]);

    useEffect(() => {
        StoreLocatorApi.GetShippingCosts(onDataLoad, () => {});
    }, []);

    useEffect(() => {
        shippingCost.postOffice === 0
            ? setPostOfficeCost('FREE')
            : setPostOfficeCost(`+$${shippingCost.postOffice.toFixed(2)}`);

        shippingCost.store === 0
            ? setStoreCost('FREE')
            : setStoreCost(`+$${shippingCost.store.toFixed(2)}`);
    }, [shippingCost]);

    const onDataLoad = (data: IShipping) => {
        setShippingCost(data);
        if (cart.shippingMethod) {
            switch (cart.shippingMethod.method) {
                case ShippingMethod.PostOffice:
                    setMethod('post-office');
                    break;
                case ShippingMethod.StorePickup:
                    setMethod('store');
                    break;
            }
        }
    };

    const styles = useShippingMethodStyles();

    const radioName = useId('methodRadio');

    return (
        <div key={'method'} className={styles.radioGroup}>
            <div className={styles.radioItem}>
                <div className={styles.radioText}>
                    <Radio
                        name={radioName}
                        value={'store'}
                        checked={method === 'store'}
                        label={'Pick up at store'}
                        data-testid={'method-radio-store'}
                        onChange={(_, data) => setMethod(data.value)}
                    />
                    <div className={styles.methodCost}>{storeCost}</div>
                </div>

                {method == 'store' && (
                    <StoreLocator
                        buttonText={'Find Store'}
                        searchType={'store'}
                        shippingCost={shippingCost}
                        overnightShipping={overnightShipping}
                        setOvernightShipping={setOvernightShipping}
                    />
                )}
            </div>

            <div className={styles.radioItem}>
                <div className={styles.radioText}>
                    <Radio
                        name={radioName}
                        value={'post-office'}
                        checked={method === 'post-office'}
                        label={'Pick up at a Post Office near you'}
                        data-testid={'method-radio-postoffice'}
                        onChange={(_, data) => setMethod(data.value)}
                    />
                    <div className={styles.methodCost}>{postOfficeCost}</div>
                </div>

                {method == 'post-office' && (
                    <StoreLocator
                        buttonText={'Find USPS'}
                        searchType={'post-office'}
                        shippingCost={shippingCost}
                        overnightShipping={overnightShipping}
                        setOvernightShipping={setOvernightShipping}
                    />
                )}
            </div>
        </div>
    );
};

export default ShippingMethodRadioGroup;
